





















































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { DemoLoginMixin } from '@/mixins'
import { SUBSCRIPTION_TYPES, CURRENCIES } from '@/constants'
import Axios from 'axios'
import { PAYMENT_PROVIDERS } from '@/store/modules/auth'
import { getBrowserCurrency } from '@/helpers/locale'

@Component({
  mixins: [DemoLoginMixin],
  components: {
    Plans: require('./Plans').default,
    CancelModal: require('./CancelModal').default,
    PaymentLink: require('./PaymentLink').default,
    VoucherField: require('./VoucherField').default,
    Paypal: require('./Paypal').default
  }
})
export default class SubscriptionPayment extends Vue {
  selectedPlan: string = SUBSCRIPTION_TYPES.Month

  loading: boolean = false
  loaded: boolean = false
  isCancelModalOpen: boolean = false
  currency: CURRENCIES = CURRENCIES.USD
  priceTotal: string = ''
  priceTotalDiscounted: string = ''

  // Voucher
  discountPercentage: number = 0
  voucherCode: string = ''
  freeSubscriptionDurationDays: number = 0
  voucherSubscriptionType: SUBSCRIPTION_TYPES | null = null

  get isFreeSubscriptionVoucher(): boolean {
    return this.discountPercentage === 100
  }

  get userSubscriptionTimestampEnd() {
    return this.$store.state.subscription.timestampEnd
  }

  get userSubscriptionActive() {
    return this.$store.state.subscription.active
  }

  get userSubscriptionCustomReason(): string {
    return this.$store.state.subscription.customReason
  }

  get userNextPaymentDue(): string {
    return this.$store.state.subscription.nextPaymentDate
  }

  get showUpgradeButton(): boolean {
    return this.$store.state.auth.userProps &&
      this.$store.state.auth.userProps.paymentProvider === PAYMENT_PROVIDERS.Mollie &&
      this.$store.state.subscription.lastSubscriptionType === SUBSCRIPTION_TYPES.Month
  }

  // async upgradeToYearSub() {
  //   const { result } = await this.$buefy.dialog.confirm({
  //     title: 'Upgrade to yearly subscription?',
  //     message: `You can upgrade to a yearly subscription for the discounted rate of <strong>50%</strong>.<br><br>The year subscription will be added to your current month. You won't lose any subscription time.`,
  //     confirmText: 'Proceed to payment'
  //   })

  //   if (result) {
  //     const { data } = await Axios.post('/user/subscription-upgrade-link')

  //     location.href = data.link
  //   }
  // }

  async startFreeSubscription() {
    this.loading = true
    try {
      await Axios.post('/voucher/start-free-subscription', {
        code: this.voucherCode
      })

      this.$store.commit('subscription/reset')
      await this.$store.dispatch('subscription/fetchStatus')

      await this.$router.push({
        name: 'dashboard'
      })
    } catch (error) {
      console.error(error)
    } finally {
      this.loading = false
    }
  }

  async created() {
    await this.$store.dispatch('subscription/waitForSubscriptionStatus')

    if (!this.$store.state.auth.user) {
      await this.$router.push({
        name: 'profile'
      })

      return
    }

    this.$store.commit('subscription/reset') // Force status renewel, user may have canceled on paypal so it needs to be correct here too

    await this.$store.dispatch('subscription/fetchStatus')

    this.currency = getBrowserCurrency()

    this.loaded = true
  }

  @Watch('voucherSubscriptionType')
  watchVoucherSubType() {
    if (this.voucherSubscriptionType === SUBSCRIPTION_TYPES.Year) {
      this.selectedPlan = SUBSCRIPTION_TYPES.Year
    } else if (this.voucherSubscriptionType === SUBSCRIPTION_TYPES.Month) {
      this.selectedPlan = SUBSCRIPTION_TYPES.Month
    }
  }
}
